<template>
  <div class="content">
    <div class="md-layout md-alignment-center">
      <div
        class="md-layout-item md-xlarge-size-75 md-large-size-100 md-small-size-100 md-xsmall-size-100"
      >
        <edit-account-form data-background-color="secondary">
        </edit-account-form>
      </div>
    </div>
  </div>
</template>

<script>
import EditAccountForm from "./Forms/EditAccountForm.vue";

export default {
  components: {
    EditAccountForm
    //UserCard
  }
};
</script>
